/**
 * Utility to manage the most recently accessed services provider ID
 * Used by the root router loader and services provider dropdown
 */

const RECENT_SERVICES_PROVIDER_KEY = 'recentServicesProviderId';

/**
 * Gets the most recently accessed services provider ID from localStorage.
 * Returns null if no recent provider is found.
 */
export function getRecentServicesProviderId(): string | null {
	return localStorage.getItem(RECENT_SERVICES_PROVIDER_KEY);
}

/**
 * Updates the most recently accessed services provider ID in localStorage
 */
export function setRecentServicesProviderId(servicesProviderId: string): void {
	localStorage.setItem(RECENT_SERVICES_PROVIDER_KEY, servicesProviderId);
}

